var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app_footer",class:_vm.isHome ? 'min_width_960' : 'min_width_1200'},[_c('span',[_vm._v("2008-"+_vm._s(_vm.curYear)+" Kingsoft Office Corporation, All Rights Reserved")])])}
var staticRenderFns = []

export { render, staticRenderFns }